import type { Special } from '@/api/endpoints/bars';

interface CompactSpecialCardProps {
  special: Special;
}

function formatPrice(price: string | null): string | undefined {
  if (!price) return undefined;
  const trimmed = price.trim();
  if (trimmed.startsWith('$')) return trimmed;
  return `$${trimmed}`;
}

export function CompactSpecialCard({ special }: CompactSpecialCardProps) {
  const formattedPrice = formatPrice(special.price);

  return (
    <div className="flex items-start justify-between py-2 border-b border-[var(--color-border)] last:border-0 gap-2">
      <div className="min-w-0 flex-1">
        <p className="font-medium text-sm">{special.name}</p>
        {special.description && (
          <p className="text-xs text-[var(--color-muted)]">
            {special.description}
          </p>
        )}
      </div>
      {formattedPrice && (
        <span className="text-sm font-bold text-accent-primary shrink-0">
          {formattedPrice}
        </span>
      )}
    </div>
  );
}
